import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, TextField } from '@mui/material';
import { loginApi } from '../../api/user';
import { useAuth } from '../../hook';
import './client.scss';

export function LoginClient() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await loginApi(form);
      await login(response.access);
    } catch (err) {
      setError(err?.message || 'No se pudo iniciar sesión.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="client-login">
      <div className="client-logo">F</div>
      <Box component="form" onSubmit={submit} className="client-login__card">
        <h2>Ingresa a tu cuenta</h2>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Email" type="email" required value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <TextField label="Contraseña" type="password" required value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })} />
        <Button type="submit" variant="contained" className="client-black-button" disabled={loading}>
          {loading ? <CircularProgress size={22} color="inherit" /> : 'Iniciar sesión'}
        </Button>
      </Box>
    </main>
  );
}
